import React, { useEffect, useState } from 'react';

const PlayerUiNameWidget = ({ creature, socket }) => {
    const [init, setInit] = useState(creature.initiative || 0);

    console.log("1", typeof creature.initiative, creature.initiative)
    console.log("2", typeof init, init)

    useEffect(() => {
        setInit(creature.initiative || 0);
    }, [creature.initiative, creature.creatureGuid]);

    const handleInit = (event) => {
        setInit(Number.parseInt(event.target.value, 10) || 0);
    };

    const submitInit = () => {
        socket.emit('creatureInitChange', init, creature.creatureGuid, 'player');
    };

    return (
        <div className='initContainerPlayerUi editHpGrowPlayerUi'>
            <div className="initMenuPlayerUi">
                <div className='initInputsController'>
                    <div className='initPlayerUi'>
                        <label className='widgetLabel acPlayerUi' htmlFor='init'>Initiative</label>
                        <input id='init' className='editStatsInputExtraPlayerUi' type='number' value={init} onChange={handleInit} onFocus={(event) => event.target.select()} onBlur={submitInit} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayerUiNameWidget;